import React, { useState, useEffect } from "react";
import { Col, Form, Row } from "react-bootstrap";
import {
  OutlinedInput,
  FormControl,
  Slider,
  Select,
  InputLabel,
  makeStyles,
  MenuItem,
} from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { ReusableOnboardingButton } from "../../../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { TopTextReusableComponent } from "../../../../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import { ToggleButtonWithYesNo } from "../../../../AllButton/ToggleButtonReuse";
import { NewInputText } from "../../../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { useFormik } from "formik";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { update_item_menu_setup } from "../../../../../../../store/actions/VendorSubscriptionAction/vendorSubscriptionGetAction";
import Media from "react-media";

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: "100%",
    marginBottom: "1rem",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

const validate = (values) => {
  const errors = {};

  // spice level start
  if (values.spice_level.customized) {
    if (
      values.spice_level.lowest_level === "" ||
      parseInt(values.spice_level.lowest_level) < 0
    ) {
      errors.spice_lowest_level = "This field is required";
    }
    if (
      values.spice_level.highest_level === "" ||
      parseInt(values.spice_level.highest_level) < 0
    ) {
      errors.spice_highest_level = "This field is required";
    }
    if (
      values.spice_level.default_level === "" ||
      parseInt(values.spice_level.default_level) < 0
    ) {
      errors.spice_default_level = "This field is required";
    }
  }
  // spice level end

  // salt level start
  if (values.salt_level.customized) {
    if (
      values.salt_level.lowest_level === "" ||
      parseInt(values.salt_level.lowest_level) < 0
    ) {
      errors.salt_lowest_level = "This field is required";
    }
    if (
      values.salt_level.highest_level === "" ||
      parseInt(values.salt_level.highest_level) < 0
    ) {
      errors.salt_highest_level = "This field is required";
    }
    if (
      values.salt_level.default_level === "" ||
      parseInt(values.salt_level.default_level) < 0
    ) {
      errors.salt_default_level = "This field is required";
    }
  }
  // salt level end

  // sugar level start
  if (values.sugar_level.customized) {
    if (
      values.sugar_level.lowest_level === "" ||
      parseInt(values.sugar_level.lowest_level) < 0
    ) {
      errors.sugar_lowest_level = "This field is required";
    }
    if (
      values.sugar_level.highest_level === "" ||
      parseInt(values.sugar_level.highest_level) < 0
    ) {
      errors.sugar_highest_level = "This field is required";
    }
    if (
      values.sugar_level.default_level === "" ||
      parseInt(values.sugar_level.default_level) < 0
    ) {
      errors.sugar_default_level = "This field is required";
    }
  }
  // sugar level end

  // fat_level  start
  if (values.fat_level.customized) {
    if (
      values.fat_level.lowest_level === "" ||
      parseInt(values.fat_level.lowest_level) < 0
    ) {
      errors.fat_lowest_level = "This field is required";
    }
    if (
      values.fat_level.highest_level === "" ||
      parseInt(values.fat_level.highest_level) < 0
    ) {
      errors.fat_highest_level = "This field is required";
    }
    if (
      values.fat_level.default_level === "" ||
      parseInt(values.fat_level.default_level) < 0
    ) {
      errors.fat_default_level = "This field is required";
    }
  }
  // fat_level  end

  // meat  start
  if (values.meat_cook_level.customized) {
    if (
      values.meat_cook_level.lowest_level === "" ||
      parseInt(values.meat_cook_level.lowest_level) < 0
    ) {
      errors.meat_lowest_level = "This field is required";
    }
    if (
      values.meat_cook_level.highest_level === "" ||
      parseInt(values.meat_cook_level.highest_level) < 0
    ) {
      errors.meat_highest_level = "This field is required";
    }
    if (
      values.meat_cook_level.default_level === "" ||
      parseInt(values.meat_cook_level.default_level) < 0
    ) {
      errors.meat_default_level = "This field is required";
    }
  }
  // meat level  end

  // egg level  start
  if (values.egg_cook_level.customized) {
    if (
      values.egg_cook_level.lowest_level === "" ||
      parseInt(values.egg_cook_level.lowest_level) < 0
    ) {
      errors.egg_lowest_level = "This field is required";
    }
    if (
      values.egg_cook_level.highest_level === "" ||
      parseInt(values.egg_cook_level.highest_level) < 0
    ) {
      errors.egg_highest_level = "This field is required";
    }
    if (
      values.egg_cook_level.default_level === "" ||
      parseInt(values.egg_cook_level.default_level) < 0
    ) {
      errors.egg_default_level = "This field is required";
    }
  }
  // meat level  end
  return errors;
};

const Personalization = (props) => {
  const classes = useStyles();
  const back = () => {
    props.onChange(2);
    window.scroll(0, 0);
  };

  useEffect(() => {
    if (!props.personalization_information) {
      props.onChange(4);
    }
  }, [props.personalization_information]);

  const onClickBack = () => {
    let formData = {};
    const token = props.auth.user.accessToken;
    if (
      props.menuCategoryItems.currentState !== 9 ||
      props.menuCategoryItems.runingTrack !== 9
    ) {
      formData.currentState = 1;
      formData.runingTrack = 2;
    }

    props.update_item_menu_setup(props.activeItemId, formData, token, back);
  };
  // const onSubmit = () => {

  //   window.scroll(0, 0);
  // };

  const onChangePersonalizationStatus = () => {
    formik.setFieldValue(
      "personalization_status",
      !formik.values.personalization_status
    );
  };
  //spice level start
  const handleSpiceLevelChange = (e, value) => {
    formik.setFieldValue("spice_level.level", value);
  };

  const onChangeSpiceLevel = () => {
    formik.setFieldValue("spice_level.value", !formik.values.spice_level.value);
  };

  const onChangeSpiceCustomization = () => {
    formik.setFieldValue(
      "spice_level.customized",
      !formik.values.spice_level.customized
    );
  };

  const spiceLevel = ["No Spice", "Mild", "Medium", "Hot", "Very Hot"];
  const spiceLevelLowest = ["No Spice", "Mild", "Medium", "Hot"];

  const [spiceLevelHighestLevel, setSpiceLevelHighestLevel] = useState([
    "Medium",
    "Hot",
    "Very Hot",
  ]);

  const [spiceLevelDefaultLevel, setSpiceLevelDefaultLevel] = useState([
    "Mild",
    "Medium",
    "Hot",
    "Very Hot",
  ]);

  const onChangeLowestSpiceLevel = (e) => {
    formik.setFieldValue("spice_level.lowest_level", e.target.value);
    formik.setFieldValue("spice_level.highest_level", "");
    formik.setFieldValue("spice_level.default_level", "");
    let indexOfItem = spiceLevel.indexOf(e.target.value);
    let data = spiceLevel.slice(indexOfItem + 1, spiceLevel.length);
    setSpiceLevelHighestLevel(data);
  };
  const onChangeHighestSpiceLevel = (e) => {
    formik.setFieldValue("spice_level.highest_level", e.target.value);
    let startIndex = spiceLevel.indexOf(formik.values.spice_level.lowest_level);
    let endIndex = spiceLevel.indexOf(e.target.value);
    let data = spiceLevel.slice(startIndex, endIndex + 1);
    setSpiceLevelDefaultLevel(data);
  };
  const onChangeDefaultSpiceLevel = (e) => {
    formik.setFieldValue("spice_level.default_level", e.target.value);
  };
  //spice level end

  //salt level start

  const handleSaltLevelChange = (e, value) => {
    formik.setFieldValue("salt_level.level", value);
  };

  const onChangeSaltLevel = () => {
    formik.setFieldValue("salt_level.value", !formik.values.salt_level.value);
  };

  const onChangeSaltCustomization = () => {
    formik.setFieldValue(
      "salt_level.customized",
      !formik.values.salt_level.customized
    );
  };

  const saltLevel = ["Low", "Normal", "Medium", "Salty", "Very Salty"];
  const saltLevelLowest = ["Low", "Normal", "Medium", "Salty"];

  const [saltLevelHighestLevel, setSaltLevelHighestLevel] = useState([
    "Normal",
    "Medium",
    "Salty",
    "Very Salty",
  ]);

  const [saltLevelDefaultLevel, setSaltLevelDefaultLevel] = useState([
    "Low",
    "Normal",
    "Medium",
    "Salty",
    "Very Salty",
  ]);

  const onChangeLowestSaltLevel = (e) => {
    formik.setFieldValue("salt_level.lowest_level", e.target.value);
    formik.setFieldValue("salt_level.highest_level", "");
    formik.setFieldValue("salt_level.default_level", "");
    let indexOfItem = saltLevel.indexOf(e.target.value);
    let data = saltLevel.slice(indexOfItem + 1, saltLevel.length);
    setSaltLevelHighestLevel(data);
  };
  const onChangeHighestSaltLevel = (e) => {
    formik.setFieldValue("salt_level.highest_level", e.target.value);
    let startIndex = saltLevel.indexOf(formik.values.salt_level.lowest_level);
    let endIndex = saltLevel.indexOf(e.target.value);
    let data = saltLevel.slice(startIndex, endIndex + 1);
    setSaltLevelDefaultLevel(data);
  };
  const onChangeDefaultSaltLevel = (e) => {
    formik.setFieldValue("salt_level.default_level", e.target.value);
  };

  //salt level end

  //sugar level start

  const handleSugarLevelChange = (e, value) => {
    formik.setFieldValue("sugar_level.level", value);
  };

  const onChangeSugarLevel = () => {
    formik.setFieldValue("sugar_level.value", !formik.values.sugar_level.value);
  };

  const onChangeSugarCustomization = () => {
    formik.setFieldValue(
      "sugar_level.customized",
      !formik.values.sugar_level.customized
    );
  };

  const sugarLevel = ["Low", "Normal", "Medium", "Sweet", "Very Sweet"];
  const sugarLevelLowest = ["Low", "Normal", "Medium", "Sweet"];

  const [sugarLevelHighestLevel, setSugarLevelHighestLevel] = useState([
    "Normal",
    "Medium",
    "Sweet",
    "Very Sweet",
  ]);

  const [sugarLevelDefaultLevel, setSugarLevelDefaultLevel] = useState([
    "Low",
    "Normal",
    "Medium",
    "Sweet",
    "Very Sweet",
  ]);

  const onChangeLowestSugarLevel = (e) => {
    formik.setFieldValue("sugar_level.lowest_level", e.target.value);
    formik.setFieldValue("sugar_level.highest_level", "");
    formik.setFieldValue("sugar_level.default_level", "");
    let indexOfItem = sugarLevel.indexOf(e.target.value);
    let data = sugarLevel.slice(indexOfItem + 1, sugarLevel.length);
    setSugarLevelHighestLevel(data);
  };
  const onChangeHighestSugarLevel = (e) => {
    formik.setFieldValue("sugar_level.highest_level", e.target.value);
    let startIndex = sugarLevel.indexOf(formik.values.sugar_level.lowest_level);
    let endIndex = sugarLevel.indexOf(e.target.value);
    let data = sugarLevel.slice(startIndex, endIndex + 1);
    setSugarLevelDefaultLevel(data);
  };
  const onChangeDefaultSugarLevel = (e) => {
    formik.setFieldValue("sugar_level.default_level", e.target.value);
  };

  //sugar level end

  //fat level start

  const handleFatLevelChange = (e, value) => {
    formik.setFieldValue("fat_level.level", value);
  };

  const onChangeFatLevel = () => {
    formik.setFieldValue("fat_level.value", !formik.values.fat_level.value);
  };

  const onChangeFatCustomization = () => {
    formik.setFieldValue(
      "fat_level.customized",
      !formik.values.fat_level.customized
    );
  };

  const fatLevel = ["Low", "Normal", "Medium", "Regular", "Extra"];
  const fatLevelLowest = ["Low", "Normal", "Medium", "Regular"];

  const [fatLevelHighestLevel, setFatLevelHighestLevel] = useState([
    "Normal",
    "Medium",
    "Regular",
    "Extra",
  ]);

  const [fatLevelDefaultLevel, setFatLevelDefaultLevel] = useState([
    "Low",
    "Normal",
    "Medium",
    "Regular",
    "Extra",
  ]);

  const onChangeLowestFatLevel = (e) => {
    formik.setFieldValue("fat_level.lowest_level", e.target.value);
    formik.setFieldValue("fat_level.highest_level", "");
    formik.setFieldValue("fat_level.default_level", "");
    let indexOfItem = fatLevel.indexOf(e.target.value);
    let data = fatLevel.slice(indexOfItem + 1, fatLevel.length);
    setFatLevelHighestLevel(data);
  };
  const onChangeHighestFatLevel = (e) => {
    formik.setFieldValue("fat_level.highest_level", e.target.value);
    let startIndex = fatLevel.indexOf(formik.values.fat_level.lowest_level);
    let endIndex = fatLevel.indexOf(e.target.value);
    let data = fatLevel.slice(startIndex, endIndex + 1);
    setFatLevelDefaultLevel(data);
  };
  const onChangeDefaultFatLevel = (e) => {
    formik.setFieldValue("fat_level.default_level", e.target.value);
  };

  //fat level end

  //Meet  level start

  const handleMeetLevelChange = (e, value) => {
    formik.setFieldValue("meat_cook_level.level", value);
  };

  const onChangeMeetLevel = () => {
    formik.setFieldValue(
      "meat_cook_level.value",
      !formik.values.meat_cook_level.value
    );
  };

  const onChangeMeetCustomization = () => {
    formik.setFieldValue(
      "meat_cook_level.customized",
      !formik.values.meat_cook_level.customized
    );
  };

  const meetLevel = ["Rare", "Medium Rare", "Medium", "Regular", "Well Done"];
  const meetLevelLowest = ["Rare", "Medium Rare", "Medium", "Regular"];

  const [meetLevelHighestLevel, setMeetLevelHighestLevel] = useState([
    "Medium Rare",
    "Medium",
    "Regular",
    "Well Done",
  ]);

  const [meetLevelDefaultLevel, setMeetLevelDefaultLevel] = useState([
    "Rare",
    "Medium Rare",
    "Medium",
    "Regular",
    "Well Done",
  ]);

  const onChangeLowestMeetLevel = (e) => {
    formik.setFieldValue("meat_cook_level.lowest_level", e.target.value);
    formik.setFieldValue("meat_cook_level.highest_level", "");
    formik.setFieldValue("meat_cook_level.default_level", "");
    let indexOfItem = meetLevel.indexOf(e.target.value);
    let data = meetLevel.slice(indexOfItem + 1, meetLevel.length);
    setMeetLevelHighestLevel(data);
  };
  const onChangeHighestMeetLevel = (e) => {
    formik.setFieldValue("meat_cook_level.highest_level", e.target.value);
    let startIndex = meetLevel.indexOf(
      formik.values.meat_cook_level.lowest_level
    );
    let endIndex = meetLevel.indexOf(e.target.value);
    let data = meetLevel.slice(startIndex, endIndex + 1);
    setMeetLevelDefaultLevel(data);
  };
  const onChangeDefaultMeetLevel = (e) => {
    formik.setFieldValue("meat_cook_level.default_level", e.target.value);
  };

  //fat level end

  // egg level start

  const handleEggLevelChange = (e, value) => {
    formik.setFieldValue("egg_cook_level.level", value);
  };

  const onChangeEggLevel = () => {
    formik.setFieldValue(
      "egg_cook_level.value",
      !formik.values.egg_cook_level.value
    );
  };

  const onChangeEggCustomization = () => {
    formik.setFieldValue(
      "egg_cook_level.customized",
      !formik.values.egg_cook_level.customized
    );
  };

  const eggLevel = [
    "Boiled",
    "Sunny Side Up",
    "Scrambled",
    "Omelette",
    "Well Done",
  ];
  const eggLevelLowest = ["Boiled", "Sunny Side Up", "Scrambled", "Omelette"];

  const [eggLevelHighestLevel, setEggLevelHighestLevel] = useState([
    "Sunny Side Up",
    "Scrambled",
    "Omelette",
    "Well Done",
  ]);

  const [eggLevelDefaultLevel, setEggLevelDefaultLevel] = useState([
    "Boiled",
    "Sunny Side Up",
    "Scrambled",
    "Omelette",
    "Well Done",
  ]);

  const onChangeLowestEggLevel = (e) => {
    formik.setFieldValue("egg_cook_level.lowest_level", e.target.value);
    formik.setFieldValue("egg_cook_level.highest_level", "");
    formik.setFieldValue("egg_cook_level.default_level", "");
    let indexOfItem = eggLevel.indexOf(e.target.value);
    let data = eggLevel.slice(indexOfItem + 1, eggLevel.length);
    setEggLevelHighestLevel(data);
  };
  const onChangeHighestEggLevel = (e) => {
    formik.setFieldValue("egg_cook_level.highest_level", e.target.value);
    let startIndex = eggLevel.indexOf(
      formik.values.egg_cook_level.lowest_level
    );
    let endIndex = eggLevel.indexOf(e.target.value);
    let data = eggLevel.slice(startIndex, endIndex + 1);
    setEggLevelDefaultLevel(data);
  };
  const onChangeDefaultEggLevel = (e) => {
    formik.setFieldValue("egg_cook_level.default_level", e.target.value);
  };

  //egg level end

  //const onChange;

  const formik = useFormik({
    initialValues: {
      personalization_text: "",
      personalization_status: false,
      spice_level: {
        value: false,
        level: 1,
        customized: false,
        //level_number: "",
        default_level: "Medium",
        highest_level: "Hot",
        lowest_level: "Mild",
      },
      salt_level: {
        value: false,
        level: 1,
        customized: false,
        //level_number: 1,
        default_level: "Medium",
        highest_level: "Salty",
        lowest_level: "Low",
      },
      sugar_level: {
        value: false,
        level: 1,
        customized: false,
        //level_number: 1,
        default_level: "Medium",
        highest_level: "Sweet",
        lowest_level: "Low",
      },
      fat_level: {
        value: false,
        level: 1,
        customized: false,
        //level_number: 1,
        default_level: "Medium",
        highest_level: "Regular",
        lowest_level: "Low",
      },
      meat_cook_level: {
        value: false,
        level: 1,
        customized: false,
        //level_number: 2,
        default_level: "Medium",
        highest_level: "Regular",
        lowest_level: "Rare",
      },
      egg_cook_level: {
        value: false,
        level: 1,
        customized: false,
        // level_number: 1,
        default_level: "Scrambled",
        highest_level: "Omelette",
        lowest_level: "Boiled",
      },
    },
    validate,
    onSubmit: (values) => {
      // props.onChange(4)
      let formData = {};
      formData = { ...formik.values };
      const token = props.auth.user.accessToken;
      if (
        props.menuCategoryItems.currentState !== 9 ||
        props.menuCategoryItems.runingTrack !== 9
      ) {
        formData.currentState = 3;
        formData.runingTrack = 4;
      }

      props.update_item_menu_setup(
        props.activeItemId,
        formData,
        token,
        onSuccess
      );
    },
  });
  const onSuccess = () => {
    if (props?.allergic_information) {
      props.onChange(4);
    } else {
      props.onChange(5);
    }

    window.scroll(0, 0);
  };

  const Capitalize = (str, name) => {
    return formik.setFieldValue(
      name,
      str.charAt(0).toUpperCase() + str.slice(1)
    );
  };

  useEffect(() => {
    if (Object.entries(props.menuCategoryItems).length !== 0) {
      let data = props.menuCategoryItems;
      formik.setFieldValue("personalization_text", data.personalization_text);
      formik.setFieldValue(
        "personalization_status",
        data.personalization_status
      );

      //spice
      if (data.spice_level && data.spice_level.customized) {
        formik.setFieldValue("spice_level", data.spice_level);
      }
      if (data.spice_level.value) {
        formik.setFieldValue("spice_level.value", true);
      }

      if (data.spice_level.value) {
        formik.setFieldValue("spice_level.level", data.spice_level.level);
      }
      // salt level
      if (data.salt_level && data.salt_level.customized) {
        formik.setFieldValue("salt_level", data.salt_level);
      }
      if (data.salt_level.value) {
        formik.setFieldValue("salt_level.value", true);
      }

      if (data.salt_level.value) {
        formik.setFieldValue("salt_level.level", data.salt_level.level);
      }

      //sugar level

      if (data.sugar_level && data.sugar_level.customized) {
        formik.setFieldValue("sugar_level", data.sugar_level);
      }
      if (data.sugar_level.value) {
        formik.setFieldValue("sugar_level.value", true);
      }

      if (data.sugar_level.value) {
        formik.setFieldValue("sugar_level.level", data.sugar_level.level);
      }

      // fat level

      if (data.fat_level && data.fat_level.customized) {
        formik.setFieldValue("fat_level", data.fat_level);
      }
      if (data.fat_level.value) {
        formik.setFieldValue("fat_level.value", true);
      }

      if (data.fat_level.value) {
        formik.setFieldValue("fat_level.level", data.fat_level.level);
      }

      // meat_cook_level
      if (data.meat_cook_level && data.meat_cook_level.customized) {
        formik.setFieldValue("meat_cook_level", data.meat_cook_level);
      }
      if (data.meat_cook_level.value) {
        formik.setFieldValue("meat_cook_level.value", true);
      }

      if (data.meat_cook_level.value) {
        formik.setFieldValue(
          "meat_cook_level.level",
          data.meat_cook_level.level
        );
      }

      //egg_cook_level
      if (data.egg_cook_level && data.egg_cook_level.customized) {
        formik.setFieldValue("egg_cook_level", data.egg_cook_level);
      }
      if (data.egg_cook_level.value) {
        formik.setFieldValue("egg_cook_level.value", true);
      }
      if (data.egg_cook_level.value) {
        formik.setFieldValue("egg_cook_level.level", data.egg_cook_level.level);
      }
    }
  }, [props.menuCategoryItems]);

  const [count, setCount] = useState(1);

  const onClickNext = (e) => {
    e.preventDefault();
    setCount(count + 1);
    formik.handleSubmit();
  };

  useEffect(() => {
    if (formik.errors && formik.errors.spice_lowest_level) {
      let spice_lowest_level = document.getElementById("spice_lowest_level");
      spice_lowest_level.focus();
    } else if (formik.errors && formik.errors.spice_highest_level) {
      let spice_highest_level = document.getElementById("spice_highest_level");
      spice_highest_level.focus();
    } else if (formik.errors && formik.errors.spice_default_level) {
      let spice_default_level = document.getElementById("spice_default_level");
      spice_default_level.focus();
    } else if (formik.errors && formik.errors.salt_lowest_level) {
      let salt_lowest_level = document.getElementById("salt_lowest_level");
      salt_lowest_level.focus();
    } else if (formik.errors && formik.errors.salt_highest_level) {
      let salt_highest_level = document.getElementById("salt_highest_level");
      salt_highest_level.focus();
    } else if (formik.errors && formik.errors.salt_default_level) {
      let salt_default_level = document.getElementById("salt_default_level");
      salt_default_level.focus();
    } else if (formik.errors && formik.errors.sugar_lowest_level) {
      let sugar_lowest_level = document.getElementById("sugar_lowest_level");
      sugar_lowest_level.focus();
    } else if (formik.errors && formik.errors.sugar_highest_level) {
      let sugar_highest_level = document.getElementById("sugar_highest_level");
      sugar_highest_level.focus();
    } else if (formik.errors && formik.errors.sugar_default_level) {
      let sugar_default_level = document.getElementById("sugar_default_level");
      sugar_default_level.focus();
    } else if (formik.errors && formik.errors.fat_lowest_level) {
      let fat_lowest_level = document.getElementById("fat_lowest_level");
      fat_lowest_level.focus();
    } else if (formik.errors && formik.errors.fat_highest_level) {
      let fat_highest_level = document.getElementById("fat_highest_level");
      fat_highest_level.focus();
    } else if (formik.errors && formik.errors.fat_default_level) {
      let fat_default_level = document.getElementById("fat_default_level");
      fat_default_level.focus();
    } else if (formik.errors && formik.errors.meat_lowest_level) {
      let meat_lowest_level = document.getElementById("meat_lowest_level");
      meat_lowest_level.focus();
    } else if (formik.errors && formik.errors.meat_highest_level) {
      let meat_highest_level = document.getElementById("meat_highest_level");
      meat_highest_level.focus();
    } else if (formik.errors && formik.errors.meat_default_level) {
      let meat_default_level = document.getElementById("meat_default_level");
      meat_default_level.focus();
    } else if (formik.errors && formik.errors.egg_lowest_level) {
      let egg_lowest_level = document.getElementById("egg_lowest_level");
      egg_lowest_level.focus();
    } else if (formik.errors && formik.errors.egg_highest_level) {
      let egg_highest_level = document.getElementById("egg_highest_level");
      egg_highest_level.focus();
    } else if (formik.errors && formik.errors.egg_default_level) {
      let egg_default_level = document.getElementById("egg_default_level");
      egg_default_level.focus();
    }
  }, [count]);
  return (
    <React.Fragment>
      <Form>
        <div className="mb-4">
          <TopTextReusableComponent
            headingText="New Item"
            headingParagraph="You have selected personalization information as part of your subscription. Please provide the data here."
          />
        </div>
        <div className="bg-gray px-3 py-2">
          <Row>
            <Col md={6}>
              <div className="d-flex align-items-center">
                <div className="f12-700 pr-3" style={{ width: 140 }}>
                  Ext Item ID :
                </div>
                <FormControl className={"w-100 bg-white"} variant="outlined">
                  <OutlinedInput
                    disabled
                    value={
                      props.menuCategoryItems && props.menuCategoryItems.ext_id
                    }
                  />
                </FormControl>
              </div>
            </Col>
          </Row>
        </div>
        <div
          className="displayItemsName f11-400 enRadius5 my-4"
          style={{ height: 50 }}
        >
          {props.menuCategoryItems && props.menuCategoryItems.name}
        </div>
        <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
          <div className="f14-700 col-8 col-md-8 col-lg-6 p-0">
            Personalization Allowed ?
          </div>
          <div className="col-4 col-md-4 col-lg-6">
            <ToggleButtonWithYesNo
              checkedBox={formik.values.personalization_status}
              onChange={() => onChangePersonalizationStatus()}
            />
          </div>
        </div>

        <div className="font_12_r c_gray mb-2 mt-2">
          Enable this toggle if personalization on the basis of Spice level,
          Salt level, Sugar level, Fried level, Meat cook level and egg cook
          level is available for this item.
        </div>
        <>
          {formik.values.personalization_status ? (
            <>
              <NewInputText
                labelText="Personalization Text"
                extraClass="mb-4 w-100"
                multiline={true}
                rows="5"
                value={formik.values.personalization_text}
                //onChange={formik.handleChange}
                onChange={(e) =>
                  Capitalize(e.target.value, "personalization_text")
                }
                name="personalization_text"
              />
              <div className="font_12_r c_gray mb-2 mt-2">
                Please put additional notes while ordering default and allowed
                customization scale is Depicted in the options below
              </div>
              <React.Fragment>
                <hr />

                <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
                  <div className="col-8 col-md-8 col-lg-6 p-0">
                    <div className="f14-700 mb-2">Spice Level</div>
                    <div className="f11-400 opacity5">Is this Item Spicy?</div>
                  </div>
                  <div className="col-4 col-md-4 col-lg-6">
                    <ToggleButtonWithYesNo
                      checkedBox={formik.values.spice_level.value}
                      onChange={() => onChangeSpiceLevel()}
                    />
                  </div>
                </div>
                <Row>
                  {formik.values.spice_level.value ? (
                    <>
                      <Col xl={8} style={{ marginRight: "20px" }}>
                        <div className="w-100 mb-4 spice">
                          <Slider
                            min={0}
                            max={4}
                            name="spice_level.level"
                            //defaultValue={0}
                            value={formik.values.spice_level.level}
                            step={1}
                            onChange={handleSpiceLevelChange}
                          />
                        </div>
                      </Col>
                      <Col xl={9}>
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="f10-400">No Spice</div>
                          <div className="f10-400">Mild</div>
                          <div className="f10-400">Medium</div>
                          <div className="f10-400">Hot</div>
                          <div className="f10-400">Very Hot</div>
                        </div>
                      </Col>
                      <Col xl={8}>
                        <div className="f11-400">
                          (Default value is set below which the customization
                          request cannot be accepted e.g. if item is medium
                          spicy its spice level cannot be reduced below that)
                        </div>
                      </Col>
                    </>
                  ) : (
                    <> </>
                  )}
                  <Col xl={12}>
                    <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
                      <div className="col-8 col-md-8 col-lg-6 p-0">
                        <div className="f11-400">
                          Is Spice level Customizable?
                        </div>
                      </div>
                      <div className="col-4 col-md-4 col-lg-6">
                        <ToggleButtonWithYesNo
                          checkedBox={formik.values.spice_level.customized}
                          onChange={() => onChangeSpiceCustomization()}
                        />
                      </div>
                    </div>
                  </Col>
                  {formik.values.spice_level.customized ? (
                    <>
                      <Col xs={6} xl={3} md={4}>
                        {/* <NewInputText
                          controlClass={"spice_lowest_level"}
                          inputType="text"
                          labelText="Lowest Level"
                          extraClass={`mb-2 w-100 ${
                            formik.errors.spice_lowest_level &&
                            formik.touched &&
                            formik.touched.spice_level &&
                            formik.touched.spice_level.lowest_level
                              ? "enError"
                              : ""
                          }`}
                          name="spice_level.lowest_level"
                          onChange={formik.handleChange}
                          value={formik.values.spice_level.lowest_level}
                          onFocusOut={formik.handleBlur}
                        /> */}
                        <FormControl
                          variant="outlined"
                          className={"w-100 mobile-f8-400"}
                        >
                          <InputLabel htmlFor="outlined-UoM">
                            Lowest Level
                          </InputLabel>
                          <Select
                            value={formik.values.spice_level.lowest_level}
                            id="spice_lowest_level"
                            // onChange={selecthandleChange}
                            onChange={(e) => onChangeLowestSpiceLevel(e)}
                            label="Lowest Level"
                            inputProps={{
                              name: "UoM",
                              id: "outlined-UoM",
                            }}
                            IconComponent={KeyboardArrowDownIcon}
                          >
                            {spiceLevelLowest.map((item, index) => (
                              <MenuItem key={index} value={item}>
                                {item}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        {formik.errors.spice_lowest_level &&
                        formik.touched &&
                        formik.touched.spice_level &&
                        formik.touched.spice_level.lowest_level ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.spice_lowest_level}
                          </div>
                        ) : null}
                      </Col>
                      <Col xs={6} xl={3} md={4}>
                        {/* <NewInputText
                          controlClass={"spice_highest_level"}
                          inputType="text"
                          labelText="Highest Level"
                          extraClass={`mb-2 w-100 ${
                            formik.errors.spice_highest_level &&
                            formik.touched &&
                            formik.touched.spice_level &&
                            formik.touched.spice_level.highest_level
                              ? "enError"
                              : ""
                          }`}
                          name="spice_level.highest_level"
                          onChange={formik.handleChange}
                          value={formik.values.spice_level.highest_level}
                          onFocusOut={formik.handleBlur}
                        /> */}
                        <FormControl
                          variant="outlined"
                          className={"w-100 mobile-f8-400"}
                        >
                          <InputLabel htmlFor="spice-highest">
                            Highest Level
                          </InputLabel>
                          <Select
                            value={formik.values.spice_level.highest_level}
                            id="spice_highest_level"
                            // onChange={selecthandleChange}
                            onChange={(e) => onChangeHighestSpiceLevel(e)}
                            label="Highest Level"
                            inputProps={{
                              name: "spice-high",
                              id: "spice-highest",
                            }}
                            IconComponent={KeyboardArrowDownIcon}
                          >
                            {spiceLevelHighestLevel.map((item, index) => (
                              <MenuItem key={index} value={item}>
                                {item}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        {formik.errors.spice_highest_level &&
                        formik.touched &&
                        formik.touched.spice_level &&
                        formik.touched.spice_level.highest_level ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.spice_highest_level}
                          </div>
                        ) : null}
                      </Col>
                      <Col xs={12} xl={3} md={4} className="mt-3">
                        {/* <NewInputText
                          controlClass={"spice_default_level"}
                          inputType="text"
                          labelText="Default Level"
                          extraClass={`mb-2 w-100 ${
                            formik.errors.spice_default_level &&
                            formik.touched &&
                            formik.touched.spice_level &&
                            formik.touched.spice_level.default_level
                              ? "enError"
                              : ""
                          }`}
                          name="spice_level.default_level"
                          onChange={formik.handleChange}
                          value={formik.values.spice_level.default_level}
                          onFocusOut={formik.handleBlur}
                        /> */}

                        <FormControl
                          variant="outlined"
                          className={"w-100 mobile-f8-400"}
                        >
                          <InputLabel htmlFor="spice-default">
                            Default Level
                          </InputLabel>
                          <Select
                            value={formik.values.spice_level.default_level}
                            id="spice_default_level"
                            // onChange={selecthandleChange}
                            onChange={(e) => onChangeDefaultSpiceLevel(e)}
                            label="Default Level"
                            inputProps={{
                              name: "spice-high",
                              id: "spice-defaultt",
                            }}
                            IconComponent={KeyboardArrowDownIcon}
                          >
                            {spiceLevelDefaultLevel.map((item, index) => (
                              <MenuItem key={index} value={item}>
                                {item}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        {formik.errors.spice_default_level &&
                        formik.touched &&
                        formik.touched.spice_level &&
                        formik.touched.spice_level.default_level ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.spice_default_level}
                          </div>
                        ) : null}
                      </Col>
                      {/* <Col xl={8}>
                        <div className="f11-400 opacity5">
                          Note: All the Scales start from 0 and above
                        </div>
                      </Col> */}
                    </>
                  ) : (
                    <> </>
                  )}
                </Row>
                <hr />
                <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
                  <div className="col-8 col-md-8 col-lg-6 p-0">
                    <div className="f14-700 mb-2">Salt Level</div>
                    <div className="f11-400 opacity5">Is this Item Salty?</div>
                  </div>
                  <div className="col-4 col-md-4 col-lg-6">
                    <ToggleButtonWithYesNo
                      checkedBox={formik.values.salt_level.value}
                      onChange={() => onChangeSaltLevel()}
                    />
                  </div>
                </div>
                <Row>
                  {formik.values.salt_level.value ? (
                    <>
                      <Col xl={8} style={{ marginRight: "20px" }}>
                        <div className="w-100 salt">
                          <Slider
                            min={0}
                            max={5}
                            name="salt_level.level"
                            //defaultValue={0}
                            value={formik.values.salt_level.level}
                            step={1}
                            onChange={handleSaltLevelChange}
                          />
                        </div>
                      </Col>
                      <Col xl={9}>
                        <div className="d-flex justify-content-between align-items-center  mb-4">
                          <div className="f10-400">No Salt</div>
                          <div className="f10-400">Low</div>
                          <div className="f10-400">Normal</div>
                          <div className="f10-400">Medium</div>
                          <div className="f10-400">Salty</div>
                          <div className="f10-400">Very Salty</div>
                        </div>
                      </Col>
                      <Col xl={8}>
                        <div className="f11-400">
                          (Default value is set below which the customization
                          request cannot be accepted e.g. if item is medium
                          spicy it spice level cannot be reduced below that)
                        </div>
                      </Col>
                    </>
                  ) : (
                    <> </>
                  )}
                  <Col xl={12}>
                    <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
                      <div className="col-8 col-md-8 col-lg-6 p-0">
                        <div className="f11-400">
                          Is Salt level Customizable?
                        </div>
                      </div>
                      <div className="col-4 col-md-4 col-lg-6">
                        <ToggleButtonWithYesNo
                          checkedBox={formik.values.salt_level.customized}
                          onChange={() => onChangeSaltCustomization()}
                        />
                      </div>
                    </div>
                  </Col>
                  {formik.values.salt_level.customized ? (
                    <>
                      <Col xs={6} xl={3} md={4}>
                        {/* <NewInputText
                          controlClass={"salt_lowest_level"}
                          inputType="text"
                          labelText="Lowest Level"
                          extraClass={`mb-2 w-100 ${
                            formik.errors.salt_lowest_level &&
                            formik.touched &&
                            formik.touched.salt_level &&
                            formik.touched.salt_level.lowest_level
                              ? "enError"
                              : ""
                          }`}
                          name="salt_level.lowest_level"
                          onChange={formik.handleChange}
                          value={formik.values.salt_level.lowest_level}
                          onFocusOut={formik.handleBlur}
                        /> */}

                        <FormControl
                          variant="outlined"
                          className={"w-100 mobile-f8-400"}
                        >
                          <InputLabel htmlFor="outlined-UoM">
                            Lowest Level
                          </InputLabel>
                          <Select
                            value={formik.values.salt_level.lowest_level}
                            id="salt_lowest_level"
                            // onChange={selecthandleChange}
                            onChange={(e) => onChangeLowestSaltLevel(e)}
                            label="Lowest Level"
                            inputProps={{
                              name: "UoM",
                              id: "outlined-UoM",
                            }}
                            IconComponent={KeyboardArrowDownIcon}
                          >
                            {saltLevelLowest.map((item, index) => (
                              <MenuItem key={index} value={item}>
                                {item}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        {formik.errors.salt_lowest_level &&
                        formik.touched &&
                        formik.touched.salt_level &&
                        formik.touched.salt_level.lowest_level ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.salt_lowest_level}
                          </div>
                        ) : null}
                      </Col>
                      <Col xs={6} xl={3} md={4}>
                        {/* <NewInputText
                          controlClass={"salt_highest_level"}
                          inputType="text"
                          labelText="Highest Level"
                          extraClass={`mb-2 w-100 ${
                            formik.errors.salt_highest_level &&
                            formik.touched &&
                            formik.touched.salt_level &&
                            formik.touched.salt_level.highest_level
                              ? "enError"
                              : ""
                          }`}
                          name="salt_level.highest_level"
                          onChange={formik.handleChange}
                          value={formik.values.salt_level.highest_level}
                          onFocusOut={formik.handleBlur}
                        /> */}

                        <FormControl
                          variant="outlined"
                          className={"w-100 mobile-f8-400"}
                        >
                          <InputLabel htmlFor="salt-highest">
                            Highest Level
                          </InputLabel>
                          <Select
                            value={formik.values.salt_level.highest_level}
                            id="salt_highest_level"
                            // onChange={selecthandleChange}
                            onChange={(e) => onChangeHighestSaltLevel(e)}
                            label="Highest Level"
                            inputProps={{
                              name: "spice-high",
                              id: "salt-highest",
                            }}
                            IconComponent={KeyboardArrowDownIcon}
                          >
                            {saltLevelHighestLevel.map((item, index) => (
                              <MenuItem key={index} value={item}>
                                {item}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        {formik.errors.salt_highest_level &&
                        formik.touched &&
                        formik.touched.salt_level &&
                        formik.touched.salt_level.highest_level ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.salt_highest_level}
                          </div>
                        ) : null}
                      </Col>
                      <Col xs={12} xl={3} md={4} className="mt-3">
                        {/* <NewInputText
                          controlClass={"salt_default_level"}
                          inputType="text"
                          labelText="Default Level"
                          extraClass={`mb-2 w-100 ${
                            formik.errors.salt_default_level &&
                            formik.touched &&
                            formik.touched.salt_level &&
                            formik.touched.salt_level.default_level
                              ? "enError"
                              : ""
                          }`}
                          name="salt_level.default_level"
                          onChange={formik.handleChange}
                          value={formik.values.salt_level.default_level}
                          onFocusOut={formik.handleBlur}
                        /> */}

                        <FormControl
                          variant="outlined"
                          className={"w-100 mobile-f8-400"}
                        >
                          <InputLabel htmlFor="salt-default">
                            Default Level
                          </InputLabel>
                          <Select
                            value={formik.values.salt_level.default_level}
                            id="salt_default_level"
                            // onChange={selecthandleChange}
                            onChange={(e) => onChangeDefaultSaltLevel(e)}
                            label="Default Level"
                            inputProps={{
                              name: "salt-high",
                              id: "spice-defaultt",
                            }}
                            IconComponent={KeyboardArrowDownIcon}
                          >
                            {saltLevelDefaultLevel.map((item, index) => (
                              <MenuItem key={index} value={item}>
                                {item}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        {formik.errors.salt_default_level &&
                        formik.touched &&
                        formik.touched.salt_level &&
                        formik.touched.salt_level.default_level ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.salt_default_level}
                          </div>
                        ) : null}
                      </Col>
                      {/* <Col xl={8}>
                        <div className="f11-400 opacity5">
                          Note: All the Scales start from 0 and above
                        </div>
                      </Col>{" "} */}
                    </>
                  ) : (
                    <> </>
                  )}
                </Row>
                <hr />
                <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
                  <div className="col-8 col-md-8 col-lg-6 p-0">
                    <div className="f14-700 mb-2">Sugar Level</div>
                    <div className="f11-400 opacity5">Is this Item Sweet?</div>
                  </div>
                  <div className="col-4 col-md-4 col-lg-6">
                    <ToggleButtonWithYesNo
                      checkedBox={formik.values.sugar_level.value}
                      onChange={() => onChangeSugarLevel()}
                    />
                  </div>
                </div>
                <Row>
                  {formik.values.sugar_level.value ? (
                    <>
                      <Col xl={8} style={{ marginRight: "20px" }}>
                        <div className="w-100 mb-4 suger">
                          <Slider
                            min={0}
                            max={5}
                            name="sugar_level.level"
                            //defaultValue={0}
                            value={formik.values.sugar_level.level}
                            step={1}
                            onChange={handleSugarLevelChange}
                          />
                        </div>
                      </Col>
                      <Col xl={9}>
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="f10-400">No Sugar</div>
                          <div className="f10-400">Low</div>
                          <div className="f10-400">Normal</div>
                          <div className="f10-400">Medium</div>
                          <div className="f10-400">Sweet</div>
                          <div className="f10-400">Very Sweet</div>
                        </div>
                      </Col>
                      <Col xl={8}>
                        <div className="f11-400">
                          (Default value is set below which the customization
                          request cannot be accepted e.g. if item is medium
                          spicy it spice level cannot be reduced below that)
                        </div>
                      </Col>
                    </>
                  ) : (
                    <> </>
                  )}
                  <Col xl={12}>
                    <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
                      <div className="col-8 col-md-8 col-lg-6 p-0">
                        <div className="f11-400 ">
                          Is Sugar level Customizable?
                        </div>
                      </div>
                      <div className="col-4 col-md-4 col-lg-6">
                        <ToggleButtonWithYesNo
                          checkedBox={formik.values.sugar_level.customized}
                          onChange={() => onChangeSugarCustomization()}
                        />
                      </div>
                    </div>
                  </Col>
                  {formik.values.sugar_level.customized ? (
                    <>
                      <Col xs={6} xl={3} md={4}>
                        {/* <NewInputText
                          extraClass="mb-2 w-100"
                          controlClass={"sugar_lowest_level"}
                          labelText="Lowest Level"
                          inputType="text"
                          extraClass={`mb-2 w-100 ${
                            formik.errors.sugar_lowest_level &&
                            formik.touched &&
                            formik.touched.sugar_level &&
                            formik.touched.sugar_level.lowest_level
                              ? "enError"
                              : ""
                          }`}
                          name="sugar_level.lowest_level"
                          onChange={formik.handleChange}
                          value={formik.values.sugar_level.lowest_level}
                          onFocusOut={formik.handleBlur}
                        /> */}
                        <FormControl
                          variant="outlined"
                          className={"w-100 mobile-f8-400"}
                        >
                          <InputLabel htmlFor="outlined-UoM">
                            Lowest Level
                          </InputLabel>
                          <Select
                            value={formik.values.sugar_level.lowest_level}
                            id="sugar_lowest_level"
                            // onChange={selecthandleChange}
                            onChange={(e) => onChangeLowestSugarLevel(e)}
                            label="Lowest Level"
                            inputProps={{
                              name: "UoM",
                              id: "outlined-UoM",
                            }}
                            IconComponent={KeyboardArrowDownIcon}
                          >
                            {sugarLevelLowest.map((item, index) => (
                              <MenuItem key={index} value={item}>
                                {item}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        {formik.errors.sugar_lowest_level &&
                        formik.touched &&
                        formik.touched.sugar_level &&
                        formik.touched.sugar_level.lowest_level ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.sugar_lowest_level}
                          </div>
                        ) : null}
                      </Col>
                      <Col xs={6} xl={3} md={4}>
                        {/* <NewInputText
                          controlClass={"sugar_highest_level"}
                          inputType="text"
                          labelText="Highest Level"
                          extraClass={`mb-2 w-100 ${
                            formik.errors.sugar_highest_level &&
                            formik.touched &&
                            formik.touched.sugar_level &&
                            formik.touched.sugar_level.highest_level
                              ? "enError"
                              : ""
                          }`}
                          name="sugar_level.highest_level"
                          onChange={formik.handleChange}
                          value={formik.values.sugar_level.highest_level}
                          onFocusOut={formik.handleBlur}
                        /> */}

                        <FormControl
                          variant="outlined"
                          className={"w-100 mobile-f8-400"}
                        >
                          <InputLabel htmlFor="salt-highest">
                            Highest Level
                          </InputLabel>
                          <Select
                            value={formik.values.sugar_level.highest_level}
                            id="sugar_highest_level"
                            // onChange={selecthandleChange}
                            onChange={(e) => onChangeHighestSugarLevel(e)}
                            label="Highest Level"
                            inputProps={{
                              name: "spice-high",
                              id: "sugar-highest",
                            }}
                            IconComponent={KeyboardArrowDownIcon}
                          >
                            {sugarLevelHighestLevel.map((item, index) => (
                              <MenuItem key={index} value={item}>
                                {item}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        {formik.errors.sugar_highest_level &&
                        formik.touched &&
                        formik.touched.sugar_level &&
                        formik.touched.sugar_level.highest_level ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.sugar_highest_level}
                          </div>
                        ) : null}
                      </Col>
                      <Col xs={12} xl={3} md={4} className="mt-3">
                        {/* <NewInputText
                          controlClass={"sugar_default_level"}
                          inputType="text"
                          labelText="Default Level"
                          extraClass={`mb-2 w-100 ${
                            formik.errors.sugar_default_level &&
                            formik.touched &&
                            formik.touched.sugar_level &&
                            formik.touched.sugar_level.default_level
                              ? "enError"
                              : ""
                          }`}
                          name="sugar_level.default_level"
                          onChange={formik.handleChange}
                          value={formik.values.sugar_level.default_level}
                          onFocusOut={formik.handleBlur}
                        /> */}
                        <FormControl
                          variant="outlined"
                          className={"w-100 mobile-f8-400"}
                        >
                          <InputLabel htmlFor="sugar-default">
                            Default Level
                          </InputLabel>
                          <Select
                            value={formik.values.sugar_level.default_level}
                            id="sugar_default_level"
                            // onChange={selecthandleChange}
                            onChange={(e) => onChangeDefaultSugarLevel(e)}
                            label="Default Level"
                            inputProps={{
                              name: "sugar-default",
                              id: "sugar-default",
                            }}
                            IconComponent={KeyboardArrowDownIcon}
                          >
                            {sugarLevelDefaultLevel.map((item, index) => (
                              <MenuItem key={index} value={item}>
                                {item}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        {formik.errors.sugar_default_level &&
                        formik.touched &&
                        formik.touched.sugar_level &&
                        formik.touched.sugar_level.default_level ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.sugar_default_level}
                          </div>
                        ) : null}
                      </Col>
                      <Col xl={8}>
                        <div className="f11-400 opacity5">
                          Note: All the Scales start from 0 and above
                        </div>
                      </Col>
                    </>
                  ) : (
                    <> </>
                  )}
                </Row>
                <hr />
                <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
                  <div className="col-8 col-md-8 col-lg-6 p-0">
                    <div className="f14-700 mb-2">Fat/Oil/Fried Level</div>
                    <div className="f11-400 opacity5">
                      Is this item Fried or Oily?
                    </div>
                  </div>
                  <div className="col-4 col-md-4 col-lg-6">
                    <ToggleButtonWithYesNo
                      checkedBox={formik.values.fat_level.value}
                      onChange={() => onChangeFatLevel()}
                    />
                  </div>
                </div>
                <Row>
                  {formik.values.fat_level.value ? (
                    <>
                      <Col xl={8} style={{ marginRight: "20px" }}>
                        <div className="w-100 mb-4">
                          {/* <Slider
                            min={0}
                            max={5}
                            name="fat_level.level"
                            value={formik.values.fat_level.level}
                            step={1}
                            onChange={handleFatLevelChange}
                          /> */}
                          <Slider
                            min={0}
                            max={5}
                            // getAriaValueText={(value) => {
                            //   return `${value}°C`;
                            // }}
                            aria-labelledby="discrete-slider-custom"
                            name="fat_level.level"
                            value={formik.values.fat_level.level}
                            step={1}
                            onChange={handleFatLevelChange}
                            style={{ fontSize: "5px" }}
                            marks={[
                              {
                                value: 0,
                                label: "No Oil",
                              },
                              {
                                value: 1,
                                label: <>&nbsp;&nbsp;Low</>,
                              },
                              {
                                value: 2,
                                label: <>&nbsp;&nbsp;&nbsp;Normal</>,
                              },
                              {
                                value: 3,
                                label: <>&nbsp;&nbsp;&nbsp;Medium</>,
                              },
                              {
                                value: 4,
                                label: <>&nbsp;&nbsp;&nbsp;Regular</>,
                              },
                              {
                                value: 5,
                                label: <>&nbsp;&nbsp;&nbsp;Extra</>,
                              },
                            ]}
                          />
                        </div>
                      </Col>
                      <Col xl={9}>
                        {/* <div className="d-flex justify-content-between align-items-center">
                          <div className="f10-400">No Oil</div>
                          <div className="f10-400">Low</div>
                          <div className="f10-400">Normal</div>
                          <div className="f10-400">Medium</div>
                          <div className="f10-400">Regular</div>
                          <div className="f10-400">Extra</div>
                        </div> */}
                      </Col>
                      <Col xl={8}>
                        <div className="f11-400 ">
                          (Default value is set below which the customization
                          request cannot be accepted e.g. if item is medium
                          spicy it spice level cannot be reduced below that)
                        </div>
                      </Col>
                    </>
                  ) : (
                    <> </>
                  )}
                  <Col xl={12}>
                    <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
                      <div className="col-8 col-md-8 col-lg-6 p-0">
                        <div className="f11-400 ">
                          Is Oil level Customizable?
                        </div>
                      </div>
                      <div className="col-4 col-md-4 col-lg-6">
                        <ToggleButtonWithYesNo
                          checkedBox={formik.values.fat_level.customized}
                          onChange={() => onChangeFatCustomization()}
                        />
                      </div>
                    </div>
                  </Col>
                  {formik.values.fat_level.customized ? (
                    <>
                      <Col xs={6} xl={3} md={4}>
                        {/* <NewInputText
                          extraClass="mb-2 w-100"
                          controlClass={"fat_lowest_level"}
                          labelText="Lowest Level"
                          inputType="text"
                          extraClass={`mb-2 w-100 ${
                            formik.errors &&
                            formik.errors.fat_lowest_level &&
                            formik.touched &&
                            formik.touched.fat_level &&
                            formik.touched.fat_level.lowest_level
                              ? "enError"
                              : ""
                          }`}
                          name="fat_level.lowest_level"
                          onChange={formik.handleChange}
                          value={formik.values.fat_level.lowest_level}
                          onFocusOut={formik.handleBlur}
                        /> */}
                        <FormControl
                          variant="outlined"
                          className={"w-100 mobile-f8-400"}
                        >
                          <InputLabel htmlFor="outlined-UoM">
                            Lowest Level
                          </InputLabel>
                          <Select
                            value={formik.values.fat_level.lowest_level}
                            id="fat_lowest_level"
                            // onChange={selecthandleChange}
                            onChange={(e) => onChangeLowestFatLevel(e)}
                            label="Lowest Level"
                            inputProps={{
                              name: "UoM",
                              id: "outlined-UoM",
                            }}
                            IconComponent={KeyboardArrowDownIcon}
                          >
                            {fatLevelLowest.map((item, index) => (
                              <MenuItem key={index} value={item}>
                                {item}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        {formik.errors &&
                        formik.errors.fat_lowest_level &&
                        formik.touched &&
                        formik.touched.fat_level &&
                        formik.touched.fat_level.lowest_level ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.fat_lowest_level}
                          </div>
                        ) : null}
                      </Col>
                      <Col xs={6} xl={3} md={4}>
                        {/* <NewInputText
                          controlClass={"fat_highest_level"}
                          inputType="text"
                          labelText="Highest Level"
                          extraClass={`mb-2 w-100 ${
                            formik.errors.fat_highest_level &&
                            formik.touched &&
                            formik.touched.fat_level &&
                            formik.touched.fat_level.highest_level
                              ? "enError"
                              : ""
                          }`}
                          name="fat_level.highest_level"
                          onChange={formik.handleChange}
                          value={formik.values.fat_level.highest_level}
                          onFocusOut={formik.handleBlur}
                        /> */}

                        <FormControl
                          variant="outlined"
                          className={"w-100 mobile-f8-400"}
                        >
                          <InputLabel htmlFor="fat-highest">
                            Highest Level
                          </InputLabel>
                          <Select
                            value={formik.values.fat_level.highest_level}
                            id="fat_highest_level"
                            // onChange={selecthandleChange}
                            onChange={(e) => onChangeHighestFatLevel(e)}
                            label="Highest Level"
                            inputProps={{
                              name: "fat-highest",
                              id: "fat-highest",
                            }}
                            IconComponent={KeyboardArrowDownIcon}
                          >
                            {fatLevelHighestLevel.map((item, index) => (
                              <MenuItem key={index} value={item}>
                                {item}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        {formik.errors.fat_highest_level &&
                        formik.touched &&
                        formik.touched.fat_level &&
                        formik.touched.fat_level.highest_level ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.fat_highest_level}
                          </div>
                        ) : null}
                      </Col>
                      <Col xs={12} xl={3} md={4} className="mt-3">
                        {/* <NewInputText
                          controlClass={"fat_default_level"}
                          inputType="text"
                          labelText="Default Level"
                          extraClass={`mb-2 w-100 ${
                            formik.errors.fat_default_level &&
                            formik.touched &&
                            formik.touched.fat_level &&
                            formik.touched.fat_level.default_level
                              ? "enError"
                              : ""
                          }`}
                          name="fat_level.default_level"
                          onChange={formik.handleChange}
                          value={formik.values.fat_level.default_level}
                          onFocusOut={formik.handleBlur}
                        /> */}
                        <FormControl
                          variant="outlined"
                          className={"w-100 mobile-f8-400"}
                        >
                          <InputLabel htmlFor="fat-default">
                            Default Level
                          </InputLabel>
                          <Select
                            value={formik.values.fat_level.default_level}
                            id="fat_default_level"
                            // onChange={selecthandleChange}
                            onChange={(e) => onChangeDefaultFatLevel(e)}
                            label="Default Level"
                            inputProps={{
                              name: "fat-default",
                              id: "fat-default",
                            }}
                            IconComponent={KeyboardArrowDownIcon}
                          >
                            {fatLevelDefaultLevel.map((item, index) => (
                              <MenuItem key={index} value={item}>
                                {item}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        {formik.errors.fat_default_level &&
                        formik.touched &&
                        formik.touched.fat_level &&
                        formik.touched.fat_level.default_level ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.fat_default_level}
                          </div>
                        ) : null}
                      </Col>
                      <Col xl={8}>
                        <div className="f11-400 opacity5">
                          Note: All the Scales start from 0 and above
                        </div>
                      </Col>
                    </>
                  ) : (
                    <> </>
                  )}
                </Row>
                <hr />
                <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
                  <div className="col-8 col-md-8 col-lg-6 p-0">
                    <div className="f14-700 mb-2">Meat Cook</div>
                    <div className="f11-400 opacity5">Is the Meat Cooked?</div>
                  </div>
                  <div className="col-4 col-md-4 col-lg-6">
                    <ToggleButtonWithYesNo
                      checkedBox={formik.values.meat_cook_level.value}
                      onChange={() => onChangeMeetLevel()}
                    />
                  </div>
                </div>

                <Row>
                  {formik.values.meat_cook_level.value ? (
                    <>
                      <Col xl={8} style={{ marginRight: "20px" }}>
                        <div className="w-100 mb-4 meat">
                          <Slider
                            min={0}
                            max={5}
                            name="fat_level.level"
                            //defaultValue={0}
                            value={formik.values.meat_cook_level.level}
                            step={1}
                            onChange={handleMeetLevelChange}
                          />{" "}
                        </div>
                      </Col>
                      <Col xl={9}>
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="f10-400">Raw</div>
                          <div className="f10-400">Rare</div>
                          <div className="f10-400">Medium Rare</div>
                          <div className="f10-400">Medium</div>
                          <div className="f10-400">Regular</div>
                          <div className="f10-400">Well Done</div>
                        </div>
                      </Col>
                      <Col xl={8}>
                        <div className="f11-400 ">
                          (Default value is set below which the customization
                          request cannot be accepted e.g. if item is medium
                          spicy it spice level cannot be reduced below that)
                        </div>
                      </Col>
                    </>
                  ) : (
                    <> </>
                  )}
                  <Col xl={12}>
                    <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
                      <div className="col-8 col-md-8 col-lg-6 p-0">
                        <div className="f11-400 ">
                          Is Meet level Customizable?
                        </div>
                      </div>
                      <div className="col-4 col-md-4 col-lg-6">
                        <ToggleButtonWithYesNo
                          checkedBox={formik.values.meat_cook_level.customized}
                          onChange={() => onChangeMeetCustomization()}
                        />
                      </div>
                    </div>
                  </Col>
                  {formik.values.meat_cook_level.customized ? (
                    <>
                      <Col xs={4} xl={3} md={4}>
                        {/* <NewInputText
                          extraClass="mb-2 w-100"
                          controlClass={"meat_lowest_level"}
                          labelText="Lowest Level"
                          inputType="text"
                          extraClass={`mb-2 w-100 ${
                            formik.errors.meat_lowest_level &&
                            formik.touched &&
                            formik.touched.meat_cook_level &&
                            formik.touched.meat_cook_level.lowest_level
                              ? "enError"
                              : ""
                          }`}
                          name="meat_cook_level.lowest_level"
                          onChange={formik.handleChange}
                          value={formik.values.meat_cook_level.lowest_level}
                          onFocusOut={formik.handleBlur}
                        /> */}
                        <FormControl
                          variant="outlined"
                          className={"w-100 mobile-f8-400"}
                        >
                          <InputLabel htmlFor="outlined-UoM">
                            Lowest Level
                          </InputLabel>
                          <Select
                            value={formik.values.meat_cook_level.lowest_level}
                            id="meat_lowest_level"
                            // onChange={selecthandleChange}
                            onChange={(e) => onChangeLowestMeetLevel(e)}
                            label="Lowest Level"
                            inputProps={{
                              name: "UoM",
                              id: "outlined-UoM",
                            }}
                            IconComponent={KeyboardArrowDownIcon}
                          >
                            {meetLevelLowest.map((item, index) => (
                              <MenuItem key={index} value={item}>
                                {item}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>

                        {formik.errors.meat_lowest_level &&
                        formik.touched &&
                        formik.touched.meat_cook_level &&
                        formik.touched.meat_cook_level.lowest_level ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.meat_lowest_level}
                          </div>
                        ) : null}
                      </Col>
                      <Col xs={6} xl={3} md={4}>
                        {/* <NewInputText
                          controlClass={"meat_highest_level"}
                          inputType="text"
                          labelText="Highest Level"
                          extraClass={`mb-2 w-100 ${
                            formik.errors.meat_highest_level &&
                            formik.touched &&
                            formik.touched.meat_cook_level &&
                            formik.touched.meat_cook_level.highest_level
                              ? "enError"
                              : ""
                          }`}
                          name="meat_cook_level.highest_level"
                          onChange={formik.handleChange}
                          value={formik.values.meat_cook_level.highest_level}
                          onFocusOut={formik.handleBlur}
                        /> */}

                        <FormControl
                          variant="outlined"
                          className={"w-100 mobile-f8-400"}
                        >
                          <InputLabel htmlFor="meat-highest">
                            Highest Level
                          </InputLabel>
                          <Select
                            value={formik.values.meat_cook_level.highest_level}
                            id="meat_highest_level"
                            // onChange={selecthandleChange}
                            onChange={(e) => onChangeHighestMeetLevel(e)}
                            label="Highest Level"
                            inputProps={{
                              name: "meat-highest",
                              id: "meat-highest",
                            }}
                            IconComponent={KeyboardArrowDownIcon}
                          >
                            {meetLevelHighestLevel.map((item, index) => (
                              <MenuItem key={index} value={item}>
                                {item}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        {formik.errors.meat_highest_level &&
                        formik.touched &&
                        formik.touched.meat_cook_level &&
                        formik.touched.meat_cook_level.highest_level ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.meat_highest_level}
                          </div>
                        ) : null}
                      </Col>
                      <Col xs={12} xl={3} md={4} className="mt-3">
                        {/* <NewInputText
                          controlClass={"meat_default_level"}
                          inputType="text"
                          labelText="Default Level"
                          extraClass={`mb-2 w-100 ${
                            formik.errors.meat_default_level &&
                            formik.touched &&
                            formik.touched.meat_cook_level &&
                            formik.touched.meat_cook_level.default_level
                              ? "enError"
                              : ""
                          }`}
                          name="meat_cook_level.default_level"
                          onChange={formik.handleChange}
                          value={formik.values.meat_cook_level.default_level}
                          onFocusOut={formik.handleBlur}
                        /> */}

                        <FormControl
                          variant="outlined"
                          className={"w-100 mobile-f8-400"}
                        >
                          <InputLabel htmlFor="meat-default">
                            Default Level
                          </InputLabel>
                          <Select
                            value={formik.values.meat_cook_level.default_level}
                            id="meat_default_level"
                            // onChange={selecthandleChange}
                            onChange={(e) => onChangeDefaultMeetLevel(e)}
                            label="Default Level"
                            inputProps={{
                              name: "meat-default",
                              id: "meat-default",
                            }}
                            IconComponent={KeyboardArrowDownIcon}
                          >
                            {meetLevelDefaultLevel.map((item, index) => (
                              <MenuItem key={index} value={item}>
                                {item}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        {formik.errors.meat_default_level &&
                        formik.touched &&
                        formik.touched.meat_cook_level &&
                        formik.touched.meat_cook_level.default_level ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.meat_default_level}
                          </div>
                        ) : null}
                      </Col>
                      {/* <Col xl={8}>
                        <div className="f11-400 opacity5">
                          Note: All the Scales start from 0 and above
                        </div>
                      </Col> */}
                    </>
                  ) : (
                    <> </>
                  )}
                </Row>
                <hr />
                <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
                  <div className="col-8 col-md-8 col-lg-6 p-0">
                    <div className="f14-700 mb-2">Egg Cook</div>
                    <div className="f11-400 opacity5">Is the Egg Cooked?</div>
                  </div>
                  <div className="col-4 col-md-4 col-lg-6">
                    <ToggleButtonWithYesNo
                      checkedBox={formik.values.egg_cook_level.value}
                      onChange={() => onChangeEggLevel()}
                    />
                  </div>
                </div>
                <Row>
                  {formik.values.egg_cook_level.value ? (
                    <>
                      <Col xl={8} style={{ marginRight: "20px" }}>
                        <div className="w-100 mb-4 egg">
                          <Slider
                            min={0}
                            max={5}
                            name="fat_level.level"
                            //defaultValue={0}
                            value={formik.values.egg_cook_level.level}
                            step={1}
                            onChange={handleEggLevelChange}
                          />
                        </div>
                      </Col>
                      <Col xl={9}>
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="f10-400">Raw</div>
                          <div className="f10-400">Boiled</div>
                          <div className="f10-400">Sunny Side Up</div>
                          <div className="f10-400">Scrambled</div>
                          <div className="f10-400">Omelette</div>
                          <div className="f10-400">Well Done</div>
                        </div>
                      </Col>
                      <Col xl={8}>
                        <div className="f11-400 ">
                          (Default value is set below which the customization
                          request cannot be accepted e.g. if item is medium
                          spicy it spice level cannot be reduced below that)
                        </div>
                      </Col>
                    </>
                  ) : (
                    <> </>
                  )}
                  <Col xl={12}>
                    <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
                      <div className="col-8 col-md-8 col-lg-6 p-0">
                        <div className="f11-400 ">
                          Is Egg level Customizable?
                        </div>
                      </div>
                      <div className="col-4 col-md-4 col-lg-6">
                        <ToggleButtonWithYesNo
                          checkedBox={formik.values.egg_cook_level.customized}
                          onChange={() => onChangeEggCustomization()}
                        />
                      </div>
                    </div>
                  </Col>
                  {formik.values.egg_cook_level.customized ? (
                    <>
                      <Col xs={6} xl={3} md={4}>
                        {/* <NewInputText
                          xtraClass="mb-2 w-100"
                          controlClass={"egg_lowest_level"}
                          labelText="Lowest Level"
                          inputType="text"
                          extraClass={`mb-2 w-100 ${
                            formik.errors.egg_lowest_level &&
                            formik.touched &&
                            formik.touched.egg_cook_level &&
                            formik.touched.egg_cook_level.lowest_level
                              ? "enError"
                              : ""
                          }`}
                          name="egg_cook_level.lowest_level"
                          onChange={formik.handleChange}
                          value={formik.values.egg_cook_level.lowest_level}
                          onFocusOut={formik.handleBlur}
                        /> */}

                        <FormControl
                          variant="outlined"
                          className={"w-100 mobile-f8-400"}
                        >
                          <InputLabel htmlFor="outlined-UoM">
                            Lowest Level
                          </InputLabel>
                          <Select
                            value={formik.values.egg_cook_level.lowest_level}
                            id="egg_lowest_level"
                            // onChange={selecthandleChange}
                            onChange={(e) => onChangeLowestEggLevel(e)}
                            label="Lowest Level"
                            inputProps={{
                              name: "UoM",
                              id: "outlined-UoM",
                            }}
                            IconComponent={KeyboardArrowDownIcon}
                          >
                            {eggLevelLowest.map((item, index) => (
                              <MenuItem key={index} value={item}>
                                {item}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        {formik.errors.egg_lowest_level &&
                        formik.touched &&
                        formik.touched.egg_cook_level &&
                        formik.touched.egg_cook_level.lowest_level ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.egg_lowest_level}
                          </div>
                        ) : null}
                      </Col>
                      <Col xs={6} xl={3} md={4}>
                        {/* <NewInputText
                          controlClass={"egg_highest_level"}
                          inputType="text"
                          labelText="Highest Level"
                          extraClass={`mb-2 w-100 ${
                            formik.errors.egg_highest_level &&
                            formik.touched &&
                            formik.touched.egg_cook_level &&
                            formik.touched.egg_cook_level.highest_level
                              ? "enError"
                              : ""
                          }`}
                          name="egg_cook_level.highest_level"
                          onChange={formik.handleChange}
                          value={formik.values.egg_cook_level.highest_level}
                          onFocusOut={formik.handleBlur}
                        /> */}

                        <FormControl
                          variant="outlined"
                          className={"w-100 mobile-f8-400"}
                        >
                          <InputLabel htmlFor="egg-highest">
                            Highest Level
                          </InputLabel>
                          <Select
                            value={formik.values.egg_cook_level.highest_level}
                            id="egg_highest_level"
                            // onChange={selecthandleChange}
                            onChange={(e) => onChangeHighestEggLevel(e)}
                            label="Highest Level"
                            inputProps={{
                              name: "egg-highest",
                              id: "egg-highest",
                            }}
                            IconComponent={KeyboardArrowDownIcon}
                          >
                            {eggLevelHighestLevel.map((item, index) => (
                              <MenuItem key={index} value={item}>
                                {item}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        {formik.errors.egg_highest_level &&
                        formik.touched &&
                        formik.touched.egg_cook_level &&
                        formik.touched.egg_cook_level.highest_level ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.egg_highest_level}
                          </div>
                        ) : null}
                      </Col>
                      <Col
                        xs={12}
                        xl={3}
                        md={4}
                        className="mt-3"
                        style={{ marginBottom: "40px" }}
                      >
                        {/* <NewInputText
                          controlClass={"egg_default_level"}
                          inputType="text"
                          labelText="Default Level"
                          extraClass={`mb-2 w-100 ${
                            formik.errors.egg_default_level &&
                            formik.touched &&
                            formik.touched.egg_cook_level &&
                            formik.touched.egg_cook_level.default_level
                              ? "enError"
                              : ""
                          }`}
                          name="egg_cook_level.default_level"
                          onChange={formik.handleChange}
                          value={formik.values.egg_cook_level.default_level}
                          onFocusOut={formik.handleBlur}
                        /> */}

                        <FormControl
                          variant="outlined"
                          className={"w-100 mobile-f8-400"}
                        >
                          <InputLabel htmlFor="egg-default">
                            Default Level
                          </InputLabel>
                          <Select
                            value={formik.values.egg_cook_level.default_level}
                            id="egg_default_level"
                            // onChange={selecthandleChange}
                            onChange={(e) => onChangeDefaultEggLevel(e)}
                            label="Default Level"
                            inputProps={{
                              name: "egg-default",
                              id: "egg-default",
                            }}
                            IconComponent={KeyboardArrowDownIcon}
                          >
                            {eggLevelDefaultLevel.map((item, index) => (
                              <MenuItem key={index} value={item}>
                                {item}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        {formik.errors.egg_default_level &&
                        formik.touched &&
                        formik.touched.egg_cook_level &&
                        formik.touched.egg_cook_level.default_level ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.egg_default_level}
                          </div>
                        ) : null}
                      </Col>
                      <Col xl={12}>
                        <div className="f11-400 opacity5">
                          Note: All the Scales start from 0 and above
                        </div>
                      </Col>
                    </>
                  ) : (
                    <> </>
                  )}
                </Row>
                <hr />
              </React.Fragment>
            </>
          ) : (
            <> </>
          )}
        </>
        <Media query="(min-width: 991px)">
          <>
            <div className="onboarding-map-setup-screen-autodetect-button mt-5 ">
              <ReusableOnboardingButton
                buttonTitle="Back Button"
                buttonClass="btn-lg btn btn-outline-secondary"
                buttonText="Back"
                buttonType="button"
                onClick={() => onClickBack()}
              />
              <ReusableOnboardingButton
                buttonTitle="Next Button"
                buttonClass="btn-lg btn btn-danger btn-lg ml-3"
                buttonText="Save and Next"
                buttonType="button"
                //onClick={onSubmit}
                onClick={(e) => onClickNext(e)}
              />
            </div>
          </>
        </Media>
        <Media query="(max-width: 991px)">
          <>
            <div className="onboarding-map-setup-screen-autodetect-button mt-5 row">
              <div className="col-6 p-0 ">
                <ReusableOnboardingButton
                  buttonTitle="Back Button"
                  buttonClass="btn-lg btn btn-outline-secondary w-100 ml-1"
                  buttonText="Back"
                  buttonType="button"
                  onClick={() => onClickBack()}
                />
              </div>
              <div className="col-6 p-0">
                <ReusableOnboardingButton
                  buttonTitle="Next Button"
                  buttonClass="btn-lg btn btn-danger btn-lg ml-3 w-100"
                  buttonText="Save and Next"
                  buttonType="button"
                  //onClick={onSubmit}
                  onClick={(e) => onClickNext(e)}
                />
              </div>
            </div>
          </>
        </Media>
      </Form>
    </React.Fragment>
  );
};

Personalization.propTypes = {
  auth: PropTypes.object.isRequired,
  update_item_menu_setup: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  tags_info: state.category && state.category.tags_info,
  menuCategoryItems:
    state.superAdminOnboarding && state.superAdminOnboarding.menuCategoryItems,
  activeItemId:
    state.superAdminOnboarding && state.superAdminOnboarding.activeItemId,
  allergic_information:
    state.superAdminOnboarding.restaurantDetails.allergic_information,
  personalization_information:
    state.superAdminOnboarding.restaurantDetails.personalization_information,
});

export default connect(mapStateToProps, { update_item_menu_setup })(
  Personalization
);
